/**
 * Hangar's architecture map in the console (plan P25, operators only): the API hands out a short-lived, API-relative link
 * to the rendered map; the page frames it in embed mode with the console's theme.
 */
export type FrameTheme = 'dark' | 'light';

/** The console's theme as the user sees it: an explicit choice on `<html data-theme>`, else the system's. */
export const effectiveTheme = (dataTheme: string | undefined, prefersDark: boolean): FrameTheme =>
  dataTheme === 'light' || dataTheme === 'dark' ? dataTheme : prefersDark ? 'dark' : 'light';

/** The frame's address: the API-relative link resolved against this console's API, in embed mode, with the theme. */
export function frameSrc(link: string, apiBase: string, theme: FrameTheme): string {
  const url = new URL(link, `${apiBase.replace(/\/+$/, '')}/`);
  url.searchParams.set('embed', '1');
  url.searchParams.set('theme', theme);
  return url.href;
}

/** The origin the frame's messages must come from (the API's), so a message from anywhere else is ignored. */
export const frameOrigin = (apiBase: string): string => new URL(apiBase).origin;
